"use client";

import { Typography } from "@/components/ui/typography";
import type { ServicesTrustProps } from "./types";
import { servicesTrustMap } from "./constants";
import { ServiceTrustCardsCarousel } from "@/components/screen/global-components/services";
import { memo } from "react";

const ServicesTrust = ({ variant = "urgent" }: ServicesTrustProps) => {
  const {
    cards,
    content: { title, description },
  } = servicesTrustMap[variant];

  return (
    <section className="section overflow-hidden bg-background-secondary">
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col gap-4 md:justify-center md:gap-2 md:w-full md:max-w-[784] md:mx-auto md:text-center">
          <Typography variant="heading4">
            <h2>{title}</h2>
          </Typography>
          {!!description && (
            <div className="flex justify-center text-gray-600">
              <Typography variant="subHeadingSm" asChild>
                <p>{description}</p>
              </Typography>
            </div>
          )}
        </div>
        <ServiceTrustCardsCarousel cards={cards} className="mt-6 lg:!mt-12" />
      </div>
    </section>
  );
};

export default memo(ServicesTrust);
